import React, { useState } from "react";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Modal,
    TextField,
    Typography
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import clsx from "clsx";
import { Note } from "../../../graphql/note.datatypes";
import { UpdateNoteModalStyles } from "../styles/UpdateNoteModalStyles";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import updateNote, { UpdateNoteInput } from "../api/updateNote.api";
import { Can } from "../../../components/Can";

interface Props {
    note: Note;
    onClose: (value: boolean) => void;
}

export const UpdateNoteModal = (props: Props) => {
    const { note, onClose } = props;
    const classes = UpdateNoteModalStyles();

    const [sendUpdateNote, updateNoteData] = updateNote();
    const { enqueueSnackbar } = useSnackbar();

    const [formState, setFormState] = useState({
        description: note.note
    });

    const onSaveClick = () => {
        const data: UpdateNoteInput = {
            data: {
                id: note.id,
                note: formState.description
            }
        };

        sendUpdateNote({ variables: data })
            .then(() => {
                onClose(true);
                enqueueSnackbar("Note updated", { variant: "success" });
            })
            .catch(() => {
                enqueueSnackbar("There was an error updating the Note", {
                    variant: "error"
                });
            });
    };

    return (
        <Modal onClose={onClose} open={true}>
            <Card className={clsx(classes.root)}>
                <LoadingOverlay loading={updateNoteData.loading}>
                    <form>
                        <CardContent>
                            <Typography
                                align="center"
                                gutterBottom
                                variant="h3"
                            >
                                Update Note
                            </Typography>
                            <Grid
                                className={classes.container}
                                container
                                spacing={3}
                            >
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Note"
                                    name="description"
                                    onChange={e => {
                                        e.persist();
                                        setFormState((oldState: any) => ({
                                            ...oldState,
                                            [e.target.name]: e.target.value
                                        }));
                                    }}
                                    value={formState.description}
                                    variant="outlined"
                                />
                            </Grid>
                        </CardContent>
                        <CardActions className={classes.actions}>
                            <Button
                                onClick={() => onClose(false)}
                                variant="contained"
                            >
                                Close
                            </Button>
                            <Can permission="notes.update">
                                <Button
                                    className={classes.saveButton}
                                    onClick={onSaveClick}
                                    variant="contained"
                                >
                                    Update
                                </Button>
                            </Can>
                        </CardActions>
                    </form>
                </LoadingOverlay>
            </Card>
        </Modal>
    );
};
